export const FETCH_POINTS_LOADING = 'FETCH_POINTS_LOADING';
export const FETCH_POINTS = 'FETCH_POINTS';
export const ERROR_FETCHING_POINTS = 'ERROR_FETCHING_POINTS';

export const FETCH_LEVEL_LOADING = 'FETCH_LEVEL_LOADING';
export const FETCH_LEVEL = 'FETCH_LEVEL';
export const ERROR_FETCHTING_LEVEL = 'ERROR_FETCHTING_LEVEL';